import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { createRepository } from '@/repositories/GenericRepository';
import type { OrganizationDetail, OrganizationPayload } from '@/types/organization';
import type { QueryParams } from '@/types/query';
import ajax from '@/utils/ajax';

const basePath = '/api/dugout/organizations';

export const dugoutOrganizationRepository = createRepository<
  OrganizationDetail,
  OrganizationPayload
>(basePath);

/**
 * Staff list, edit and delete for organizations. Distinct from OrganizationRepository, which
 * searches the public (visible-to-public only) /api/organizations/ endpoint
 * for the ROI and referral pickers.
 */
const DugoutOrganizationRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async list(params: QueryParams = {}) {
      return dugoutOrganizationRepository.list({ host, params });
    },

    async get(id: string) {
      return dugoutOrganizationRepository.get({ host, id });
    },

    async update(id: string, data: Partial<OrganizationPayload>) {
      return dugoutOrganizationRepository.update({ host, id, data });
    },

    async delete(id: string) {
      return dugoutOrganizationRepository.delete({ host, id });
    },

    async deletionBlockers(id: string): Promise<string[]> {
      const response = await ajax.get({ url: `${host}${basePath}/${id}/deletion_blockers/` });
      return (response.data as { blockers: string[] }).blockers;
    }
  };
};

export default DugoutOrganizationRepository;
